import { createApp } from "vue";
import "./registerServiceWorker";
import App from "./App.vue";
// Cookies
import Cookies from "vue-cookies";
//import { StreamBarcodeReader } from 'vue-barcode-reader'

// Datetime

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import {
  VApp,
  VMain,
  VContainer,
  VBtn,
  VDataTable,
  VSelect,
  VTextField,
  VTabs,
  VTab,
  VTabsWindow,
  VTabsWindowItem,
  VRow,
  VCol,
  VTooltip,
  VAppBar,
  VIcon,
  VSpacer,
  VFooter,
  VSnackbar,
  VFab,
  VForm,
  VRadio,
  VRadioGroup,
  VCheckbox,
  VCard,
  VCardText,
  VCardTitle,
  VCardActions,
  VDialog,
  VWindow,
  VWindowItem,
  VAppBarTitle,
  VMenu,
  VFabTransition,
} from "vuetify/components";
import { Ripple } from "vuetify/directives";
//import * as components from 'vuetify/components'
//import * as directives from 'vuetify/directives'

//router
import router from "./router";
//store
import store from "./store";

const vuetify = createVuetify({
  //components, directives
  components: {
    VApp,
    VMain,
    VContainer,
    VBtn,
    VDataTable,
    VSelect,
    VTextField,
    VTabs,
    VTab,
    VTabsWindow,
    VTabsWindowItem,
    VRow,
    VCol,
    VTooltip,
    VAppBar,
    VIcon,
    VSpacer,
    VFooter,
    VSnackbar,
    VFab,
    VForm,
    VRadio,
    VRadioGroup,
    VCheckbox,
    VCard,
    VCardText,
    VCardTitle,
    VCardActions,
    VDialog,
    VWindow,
    VWindowItem,
    VAppBarTitle,
    VMenu,
    VFabTransition,
  },
  directives: {
    Ripple,
  },
});
// Defer ResizeObserver callbacks to the next animation frame to prevent
// "ResizeObserver loop limit exceeded" errors triggered by Vuetify layout updates.
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

createApp(App)
  .use(vuetify)
  .use(router)
  .use(store)
  .use(Cookies)
  //use(StreamBarcodeReader).
  //use(Datetime).
  .mount("#app");
